/*
 * <uj-countdown data-end="ISO" data-start="ISO">: fills [data-unit=d|h|m|s]
 * and the [data-progress] bar (share of the window already elapsed). The
 * end/start come from Theme settings > Giveaway; the multiplier schedule is
 * never sent to the browser.
 */
if (!customElements.get('uj-countdown')) {
  customElements.define(
    'uj-countdown',
    class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.start = Date.parse(this.dataset.start);
        this.units = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.units[el.dataset.unit] = el));
        this.bar = this.querySelector('[data-progress]');
        if (Number.isNaN(this.end)) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const now = Date.now();
        const left = Math.max(0, Math.floor((this.end - now) / 1000));
        const parts = {
          d: Math.floor(left / 86400),
          h: Math.floor((left % 86400) / 3600),
          m: Math.floor((left % 3600) / 60),
          s: left % 60,
        };
        for (const [k, v] of Object.entries(parts)) {
          if (this.units[k]) this.units[k].textContent = String(v).padStart(2, '0');
        }
        this.setAttribute(
          'aria-label',
          `${parts.d} days, ${parts.h} hours, ${parts.m} minutes, ${parts.s} seconds left`
        );
        if (this.bar && !Number.isNaN(this.start) && this.end > this.start) {
          const done = Math.min(1, Math.max(0, (now - this.start) / (this.end - this.start)));
          this.bar.style.width = `${(done * 100).toFixed(1)}%`;
        }
        if (left === 0) clearInterval(this.timer);
      }
    }
  );
}
